<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/services">Services</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Relocation Services
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Relocation Services</h2>
              <p class="lead">
                Although our company handles single IT asset moves, we render
                this service but not limited to it, because we are much more
                than a hardware moving service. Our company has a globally
                deployed infrastructure of full-time hardware field engineers,
                cross-trained on multiple platforms, offering its customers a
                wide range of skilled services in addition to its relocation and
                project management expertise.
              </p>
              <p class="lead">
                You can depend on our expertise and professionals to plan and
                execute every relocation project, since the depth of their
                expertise ensures every asset transition is handled excellently,
                down to the smallest details.
              </p>
              <p class="lead">
                Our team understands that every data center relocation is unique
                so that they can tailor an excellent relocation service
                according to the specific requirements of your company and your
                circumstances. Whether you are looking for local IT asset moves,
                basic pack-and-ship operations, full relocation planning, or
                project management, and execution - our competent experts have
                the most convenient solution for you.
              </p>

              <p class="lead">
                Our company provides robust, and excellent services narrowed and
                unique to your business needs which include:
              </p>

              <ul class="lead">
                <li>Audit and analysis</li>
                <li>Duplicating and replicating of equipment</li>
                <li>Availability of spare parts</li>
                <li>Uninstallation of your infrastructure</li>
                <li>Packaging of your equipment for the transportation</li>
                <li>Transportation and assurance</li>
                <li>Restarting the whole system</li>
              </ul>
          
            </div>

            <div class="col-lg-4">
              <ServicesSideNav></ServicesSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ServicesSideNav from "./ServicesSideNav";
export default {
  name: "cloud overview",
  components: {
    ServicesSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
